var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.912,
    height: 28.25,
    viewBox: "0 0 25.912 28.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_live_help_24px",
    d: "M26.033,2H5.879A2.789,2.789,0,0,0,3,4.69V23.524a2.789,2.789,0,0,0,2.879,2.69h5.758l4.319,4.036,4.319-4.036h5.758a2.8,2.8,0,0,0,2.879-2.69V4.69A2.8,2.8,0,0,0,26.033,2ZM17.4,23.524H14.516v-2.69H17.4ZM20.375,13.1l-1.3,1.238A4.449,4.449,0,0,0,17.4,18.143H14.516V17.47A5.242,5.242,0,0,1,16.2,13.663l1.785-1.695a2.548,2.548,0,0,0,.849-1.9,2.8,2.8,0,0,0-2.879-2.69,2.8,2.8,0,0,0-2.879,2.69H10.2A5.578,5.578,0,0,1,15.956,4.69a5.578,5.578,0,0,1,5.758,5.381A4.145,4.145,0,0,1,20.375,13.1Z",
    transform: "translate(-3 -2)",
    fill: "#009ebe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistsBlue);
export default __webpack_public_path__ + "static/media/checklistsBlue.1170d803b78ada62566bd7ac283ce370.svg";
export { ForwardRef as ReactComponent };